export enum HttpCodes {
  HTTP_UNAUTHORIZED = 401,
  HTTP_NO_CONTENT = 204,
}
